<!-- TOP BAR -->
<!-- On desktop the top bar gets the menus of every level, for its search (see `searchMenuItems`).
     No application switcher: it jumps between the product applications of a platform, which is no use from the
     console (the BackOffice picks platforms with its own selector). -->
<overa-topbar
  [menuItems]="deviceType == DeviceType.Desktop ? searchMenuItems : menuItems"
  [menubarItems]="menubarItems"
  [showAppSwitcher]="false"></overa-topbar>

<!-- MASTER CONTAINER -->
<!-- Right padding = the open AI drawer (see AiDrawerSpaceService): the scroll container and its
     scrollbar end where the drawer starts instead of running underneath it. -->
<div class="master-container-overa"
     [class.master-container-overa--drawer-animating]="aiDrawer.animating()"
     [style.padding-right.px]="aiDrawerReservedWidth">

  <!-- Left Sidebar Container -->
  <nav *ngIf="deviceType == DeviceType.Desktop" class="left-sidebar-container-overa">

    <!-- Left Sidebar Component -->
    <div class="sidebar-overa" [class.collapsed]="isSidebarCollapsed">
      <overa-left-sidebar
        [menuItems]="sidebarMenuItems"
        [isCollapsed]="isSidebarCollapsed"
        [activeRoute]="activeRoute">
      </overa-left-sidebar>
    </div>

    <!-- Button collapse/expand sidebar -->
    <div class="sidebar-arrow" [ngClass]="{'expanded': !isSidebarCollapsed}" (click)="toggleSidebar()">
      <img src="../../assets/img/arrow.svg" alt="Toggle Sidebar" />
    </div>

  </nav>

  <!-- Mobile/tablet: the menu is the top bar's hamburger (overa-topbar draws its own responsive menu). -->

  <!-- Main content -->
  <div class="main-content-overa">
    <overa-breadcrumb [breadcrumbItems]="breadcrumbItems"></overa-breadcrumb>
    <router-outlet></router-outlet>
  </div>

</div>

<!-- AI ASSISTANT -->
<!-- Asistente general de la consola: botón flotante + ventana, en todas las pantallas y sin recrearse al
     navegar. Agente, textos y chips salen de la sección `AiChat` del appsettings de la UI (ver
     LayoutComponent.aiChat y AiChatSettings.cs). Las pantallas con asistente propio (Dynamic Studio, vistas
     dinámicas) siguen con el suyo. -->
<overa-ai-chat-panel
  [structuredContext]="true"
  [listenExternalQuestions]="true"
  *ngIf="aiChatVisible"
  presentation="floating"
  [panelOpen]="aiChatOpen"
  (panelOpenChange)="aiChatOpen = $event"
  chatMode="agent"
  requestMode="chat"
  [agentName]="aiChat.agentName"
  instanceId="backoffice-main"
  historyScope="agent"
  aiKind="chat"
  [panelTitle]="aiChatTitle"
  [brandIcon]="aiChat.brandIcon || 'pi pi-sparkles'"
  [welcomeText]="aiChatWelcomeText"
  [quickActions]="aiChatQuickActions"
  [inputPlaceholderText]="aiChatPlaceholder"
  [contextSections]="aiChatContextSections()"
  [tier]="aiChat.tier || undefined"
  [tierSelectable]="aiChat.tierSelectable === true"
  [showReasoning]="aiChat.showReasoning === true"
  [showUsage]="aiChat.showUsage === true"
  [showUsageCost]="aiChatShowUsageCost"
  [thinkLongerAvailable]="aiChat.thinkLonger === true"
  [launcherLabel]="aiChatLauncherLabel"
  [(launcherHidden)]="aiChatLauncherHidden"
  [micEnabled]="chatMicEnabled"
  [navigationTargets]="aiChatNavigationTargets"
  (navigate)="onAiChatNavigate($event)"
  [watchSignal]="aiChatWatchSignal"
></overa-ai-chat-panel>
